import { CommonCodeRequirementKey } from 'src/store/useCommonCodeStore';
import { CommonCodeRequirement } from './CommonCodeValidateContext';

//경고문 모음 객체
export const COMMON_CODE_REQUIREMENT_CONFIG: Partial<Record<CommonCodeRequirementKey, { key: CommonCodeRequirementKey; message: string }>> = {
	areaCdList: {
		key: 'areaCdList',
		message: '관리지역 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	bankAcctTypeList: {
		key: 'bankAcctTypeList',
		message: '예적금구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	bankCdList: {
		key: 'bankCdList',
		message: '은행 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	brandCdList: {
		key: 'brandCdList',
		message: '브랜드 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	compCdList: {
		key: 'compCdList',
		message: '사업장 정보가 등록되지 않았습니다. 사업장 정보를 등록해주세요.',
	},
	carModelList: {
		key: 'carModelList',
		message: '차종 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	customTypeList: {
		key: 'customTypeList',
		message: '거래유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	downtimeValueList: {
		key: 'downtimeValueList',
		message: '비가동사유 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	devloperList: {
		key: 'devloperList',
		message: '개발자 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	employeeCdList: {
		key: 'employeeCdList',
		message: '작업자 코드가 등록되지 않았습니다. 사용자 정보를 등록해주세요.',
	},
	equipmentCdList: {
		key: 'equipmentCdList',
		message: '시험기기 정보가 등록되지 않았습니다. 설비 정보를 등록해주세요.',
	},
	faultyValueList: {
		key: 'faultyValueList',
		message: '불량유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	interesttypeList: {
		key: 'interesttypeList',
		message: '이자유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	inoutBoundList: {
		key: 'inoutBoundList',
		message: '입출고구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	inoutClassList: {
		key: 'inoutClassList',
		message: '입출고구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	inoutMethodList: {
		key: 'inoutMethodList',
		message: '입출고방법 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	inoutTypeList: {
		key: 'inoutTypeList',
		message: '입출고유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	inspectionStatusList: {
		key: 'inspectionStatusList',
		message: '점검유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	inspectionValueList: {
		key: 'inspectionValueList',
		message: '검사값유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	itemAccountList: {
		key: 'itemAccountList',
		message: '품목계정 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	itemGroupList: {
		key: 'itemGroupList',
		message: '품목그룹 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	itemStatusList: {
		key: 'itemStatusList',
		message: '품목상태 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	layerList: {
		key: 'layerList',
		message: '층 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	jobTeamList: {
		key: 'jobTeamList',
		message: '작업팀 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	moldClassList: {
		key: 'moldClassList',
		message: '금형분류 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	moldTypeList: {
		key: 'moldTypeList',
		message: '금형유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	cleanTypeList: {
		key: 'cleanTypeList',
		message: '세척구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	moneyCdList: {
		key: 'moneyCdList',
		message: '화폐단위 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	materialIntypeList: {
		key: 'materialIntypeList',
		message: '자재투입유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	ordTypeList: {
		key: 'ordTypeList',
		message: '지시구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	orgCdList: {
		key: 'orgCdList',
		message: '부서 코드가 등록되지 않았습니다. 조직 정보를 등록해주세요.',
	},
	paycollectTargetList: {
		key: 'paycollectTargetList',
		message: '수금/지급 대상 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	prodStockTypeList: {
		key: 'prodStockTypeList',
		message: '생산재고 발생기준 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	unitList: {
		key: 'unitList',
		message: '단위 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	vatTypeList: {
		key: 'vatTypeList',
		message: '부가세구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	warehouseCdList: {
		key: 'warehouseCdList',
		message: '창고 정보가 등록되지 않았습니다. 창고 정보를 등록해주세요.',
	},
	workPlaceList: {
		key: 'workPlaceList',
		message: '공정 정보가 등록되지 않았습니다. 공정 정보를 등록해주세요.',
	},
	workProcessList: {
		key: 'workProcessList',
		message: '공정유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	wmsCdList: {
		key: 'wmsCdList',
		message: '물류센터 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	yesNoList: {
		key: 'yesNoList',
		message: '예/아니오 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
};

//이하 각 화면에서 사용할 COMMON_CODE_REQUIREMENT_CONFIG의 키 보관

export const EQM2010_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'inspectionStatusList',
	'yesNoList',
];

export const MST1010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'brandCdList',
	'itemAccountList',
	'itemGroupList',
	'prodStockTypeList',
	'unitList',
	'yesNoList',
];

export const MST1011_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'brandCdList',
	'itemAccountList',
	'itemGroupList',
	'unitList',
];

export const MST1020_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'brandCdList',
	'itemAccountList',
	'itemGroupList',
	'materialIntypeList',
	'unitList',
];

export const EQM4010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moldClassList',
	'moldTypeList',
	'cleanTypeList',
];

export const MST1110_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'wmsCdList',
	'warehouseCdList',
];

export const MST2010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'areaCdList',
	'customTypeList',
	'moneyCdList',
];

export const MST3010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'wmsCdList',
	'workProcessList',
	'yesNoList',
];

export const MST3040_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'layerList',
];

export const MST3050_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'layerList',
];

export const MST4010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'cycleList',
	'eqmTypeList',
	'eqmStatusList',
	'compCdList',
	'orgCdList',
	'workPlaceList',
	'yesNoList',
];

export const EQM2020_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'inspectionStatusList',
	'inspectionValueList',
	'yesNoList',
];

export const EQM2070_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'cycleList',
	'yesNoList',
];

export const EQM2080_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'cycleList',
	'yesNoList',
];

export const MST4030_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'inspectionStatusList',
];

export const MST4030_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'eqmStatusList',
	'compCdList',
	'orgCdList',
	'workPlaceList',
];

export const MST4040_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'moldClassList',
	'moldTypeList',
	'eqmStatusList',
	'yesNoList',
];

export const PRD1010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
];

export const PRD2010_R01_HEADERROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'employeeCdList',
	'jobTeamList',
	'ordTypeList',
	'workPlaceList',
];

export const PRD3010_R01_DOWNTIMEROW_VALIDATE: CommonCodeRequirementKey[] = [
	'downtimeValueList',
];

export const PRD3010_R01_HEADERROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'itemStatusList',
];

export const PRD3010_R01_INSPECTROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

export const PRD3010_R01_LOTROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const PRD3011_R01_DOWNTIMEROW_VALIDATE: CommonCodeRequirementKey[] = [
	'downtimeValueList',
];

export const PRD3011_R01_HEADERROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'itemStatusList',
];

export const PRD3011_R01_INSPECTROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

export const PRD3012_R01_DOWNTIMEROW_VALIDATE: CommonCodeRequirementKey[] = [
	'downtimeValueList',
];

export const PRD3012_R01_HEADERROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'itemStatusList',
];

export const PRD3012_R01_INSPECTROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

export const PRD3012_R01_LOTROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const PUR1030_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moneyCdList',
	'vatTypeList',
	'wmsCdList',
	'warehouseCdList',
];

export const PUR2010_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moneyCdList',
	'vatTypeList',
	'wmsCdList',
];

export const SAL1010_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moneyCdList',
	'vatTypeList',
	'wmsCdList',
];

export const SAL1011_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moneyCdList',
	'vatTypeList',
	'wmsCdList',
];

export const SAL2020_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moneyCdList',
	'vatTypeList',
];

export const SAL6010_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'moneyCdList',
	'vatTypeList',
];

export const SYS2010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'devloperList',
	'devStsList',
	'yesNoList',
];

export const SYS3010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'yesNoList',
];

export const SYS3020_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'yesNoList',
];

export const SYS3060_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'yesNoList',
];

export const SYS4010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'moneyCdList',
	'paycollectTargetList',
	'yesNoList',
];

export const SYS4030_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutBoundList',
	'wmsCdList',
	'yesNoList',
];

export const SYS4090_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'bankAcctTypeList',
	'bankCdList',
	'compCdList',
	'interesttypeList',
];

export const TQC1020_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

export const TQC2060_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'carModelList',
	'equipmentCdList',
];

export const TQC5010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'inspectionValueList',
];

export const WMS1020_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'inoutTypeList',
	'wmsCdList',
	'warehouseCdList',
];

export const WMS1021_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'inoutTypeList',
	'wmsCdList',
	'warehouseCdList',
];

export const WMS1022_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'inoutTypeList',
	'wmsCdList',
	'warehouseCdList',
];

export const WMS1030_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutTypeList',
	'wmsCdList',
	'warehouseCdList',
];

export const WMS1030_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS1031_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutTypeList',
	'wmsCdList',
	'warehouseCdList',
];

export const WMS1031_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS1130_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS1130_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'wmsCdList',
	'warehouseCdList',
	'inoutTypeList',
];

export const WMS1131_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS1131_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'wmsCdList',
	'warehouseCdList',
	'inoutTypeList',
];

export const WMS1140_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS1140_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'wmsCdList',
	'warehouseCdList',
	'inoutTypeList',
];

export const WMS1141_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS1141_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutClassList',
	'inoutMethodList',
	'wmsCdList',
	'warehouseCdList',
	'inoutTypeList',
];

export const WMS2090_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS2090_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutMethodList',
	'wmsCdList',
	'warehouseCdList',
];

export const WMS2091_R01_DETAIL_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

export const WMS2091_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'inoutMethodList',
	'wmsCdList',
	'warehouseCdList',
];

//실제 검증을 위해 공통코드 검증 모듈에 전달할 객체 생성
export const buildCommonCodeRequirements = (
	keys: CommonCodeRequirementKey[],
	lists: Partial<Record<CommonCodeRequirementKey, unknown[]>>,
): CommonCodeRequirement[] => keys.map((key) => ({
	key,
	message: COMMON_CODE_REQUIREMENT_CONFIG[key]?.message ?? '',
	list: lists[key] ?? [],
}));
